










import { Vue, Component } from 'vue-property-decorator';
import TipoDispositivo from '@/pantallas/TipoDispositivo/TipoDispositivo.vue';

@Component({
  components: { TipoDispositivo },
})
export default class TipoDispositivoPantalla extends Vue {}
